export default __webpack_public_path__ + "static/media/bottlegourd.6514af36.png";